import { Record } from 'immutable'
import {
  NotificationsState,
  reducer as notifications,
} from 'react-notification-system-redux'
import { RouterState } from 'connected-react-router'

import * as ActivityFeed from '@app/components/ActivityFeed/modules/activityFeed'
import * as AssignmentForm from '@app/components/AssignmentForm/modules/assignmentForm'
import * as BrokeragePipelineEdit from '@app/components/PipelineEdit/modules/pipelineEdit'
import * as ChangePassword from '@app/components/ChangePasswordModal/modules/changePassword'
import * as CommentEditor from '@app/components/CommentEditor/modules/commentEditor'
import * as ContextReminder from '@app/components/ContextReminder/modules/contextReminder'
import * as CriticalDatesEdit from '@app/components/CriticalDatesEditModal/modules/criticalDatesEdit'
import * as DueDiligenceItemEdit from '@app/components/DueDiligenceItemEdit/modules/dueDiligenceItemEdit'
import * as Feedback from '@app/components/Feedback/modules/feedback'
import * as FeedItems from '@app/components/FeedItem/modules/feedItems'
import * as FeedItemEditor from '@app/components/FeedItemEditor/modules/feedItemEditor'
import * as FileUpload from '@app/components/FileUpload/modules/fileUpload'
import * as GlobalSearch from '@app/components/GlobalSearch/modules/globalSearch'
import * as MentionEditor from '@app/components/MentionEditor/modules/mentionEditor'
import * as PreferencesEdit from '@app/components/PreferencesModal/modules/preferencesEdit'
import * as PropertyEdit from '@app/components/PropertyEdit/modules/propertyEdit'
import * as QuickAdd from '@app/components/QuickAddModal/modules/quickAdd'
import * as ShareAttachment from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import * as SignTransfer from '@app/components/SignTransferModal/modules/signTransfer'
import * as ReactiveLayout from '@app/layouts/ReactiveLayout/modules/ReactiveLayout'
import * as ForgotPassword from '@app/routes/Account/ForgotPassword/modules/forgotPassword'
import * as Login from '@app/routes/Account/Login/modules/login'
import * as MapView from '@app/routes/Map/modules/mapView'
import * as GuestList from '@app/routes/Administration/Guests/List/modules/guestList'
import * as GuestView from '@app/routes/Administration/Guests/View/modules/guestView'
import * as SignTypeList from '@app/routes/Administration/SignTypes/List/modules/signTypesList'
import * as TeamsList from '@app/routes/Administration/Teams/List/modules/teamsList'
import * as TeamView from '@app/routes/Administration/Teams/View/modules/teamView'
import * as UserEdit from '@app/routes/Administration/Users/Edit/modules/userEdit'
import * as UsersList from '@app/routes/Administration/Users/List/modules/userList'
import * as UserView from '@app/routes/Administration/Users/View/modules/userView'
import * as LeadsList from '@app/routes/Brokerage/Leads/List/modules/leadsList'
import * as ListingEdit from '@app/components/ListingEdit/modules/listingEdit'
import * as ListingsList from '@app/routes/Brokerage/Listings/List/modules/listingsList'
import * as ListingView from '@app/routes/Brokerage/Listings/View/modules/listing'
import * as ListingSelector from '@app/components/ListingSelector/modules/listingSelector'
import * as PipelineList from '@app/routes/Brokerage/Pipeline/List/modules/pipelineList'
import * as PipelineView from '@app/routes/Brokerage/Pipeline/View/modules/pipeline'
import * as AssignmentsCalendar from '@app/routes/Calendars/Assignments/modules/assignmentsCalendar'
import * as BrokeragePipelinesCalendar from '@app/routes/Calendars/BrokeragePipelines/modules/brokeragePipelinesCalendar'
import * as DueDiligenceCalendar from '@app/routes/Calendars/DueDiligence/modules/dueDiligenceCalendar'
import * as ListingsCalendar from '@app/routes/Calendars/Listings/modules/listingsCalendar'
import * as ConnectionEdit from '@app/routes/Connections/Edit/modules/connectionEdit'
import * as ConnectionsList from '@app/routes/Connections/List/modules/connectionsList'
import * as ConnectionView from '@app/routes/Connections/View/modules/connectionView'
import * as CityEdit from '@app/routes/Development/Cities/Edit/modules/cityEdit'
import * as CitiesList from '@app/routes/Development/Cities/List/modules/citiesList'
import * as CityView from '@app/routes/Development/Cities/View/modules/cityView'
import * as ClientEdit from '@app/routes/Development/Clients/Edit/modules/clientEdit'
import * as ClientList from '@app/routes/Development/Clients/List/modules/clientsList'
import * as DevelopmentSiteEdit from '@app/routes/Development/Clients/Sites/Edit/modules/developmentSiteEdit'
import * as SiteList from '@app/routes/Development/Clients/Sites/List/modules/siteList'
import * as DevelopmentSiteView from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import * as ClientDetail from '@app/routes/Development/Clients/View/modules/developmentClientDetail'
import * as EarnestMoneyList from '@app/routes/Development/EarnestMoney/List/modules/earnestMoneyList'
import * as DevelopmentProjects from '@app/routes/Development/Projects/List/modules/developmentProjectsList'
import * as FormsList from '@app/routes/Forms/List/modules/formsList'
import * as NotificationsList from '@app/routes/Notifications/List/modules/notificationsList'
import * as AssignmentsList from '@app/routes/Personal/Assignments/List/modules/assignmentsList'
import * as AssignmentDetail from '@app/routes/Personal/Assignments/View/modules/assignmentDetail'
import * as GoalList from '@app/routes/Personal/Goals/List/modules/goalsList'
import * as MessageList from '@app/routes/Personal/Messages/List/modules/messagesList'
import * as TodoList from '@app/routes/Personal/Todos/List/modules/todoList'
import * as PropertiesList from '@app/routes/Properties/Properties/List/modules/propertiesList'
import * as PropertyView from '@app/routes/Properties/Properties/View/modules/property'
import * as EarnestMoneyListReport from '@app/routes/Reports/EarnestMoney/List/modules/earnestMoneyList'
import * as ProjectedEarnings from '@app/routes/Reports/ProjectedEarnings/List/modules/projectedEarnings'
import * as ProjectedProfit from '@app/routes/Reports/ProjectedProfit/List/modules/projectedProfit'
import * as SignsList from '@app/routes/Reports/Signs/List/modules/signsList'
import * as SoldPropertiesList from '@app/routes/Reports/SoldProperties/List/modules/soldPropertiesList'
import * as SuccessStoriesList from '@app/routes/Properties/SuccessStories/List/modules/successStoriesList'
import * as SuccessStoriesEdit from '@app/routes/Properties/SuccessStories/Edit/modules/successStoriesEdit'
import * as SystemNotifications from '@app/store/modules/systemNotifications'
import * as Account from './modules/account'
import * as Global from './modules/global'
import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'

// The top-level state object
export interface IApplicationState {
  account: Account.IAccountState
  activityFeed: ActivityFeed.IActivityFeedState
  assignmentDetail: AssignmentDetail.IAssignmentDetailState
  assignmentForm: AssignmentForm.IAssignmentFormState
  assignmentsCalendar: AssignmentsCalendar.IAssignmentsCalendarState
  assignmentsList: AssignmentsList.IAssignmentsListState
  brokeragePipelinesCalendar: BrokeragePipelinesCalendar.IBrokeragePipelinesCalendarState
  brokeragePipelineEdit: BrokeragePipelineEdit.IPipelineEditState
  changePassword: ChangePassword.IChangePasswordState
  citiesList: CitiesList.ICitiesListState
  cityEdit: CityEdit.ICityEditState
  cityView: CityView.ICityViewState
  clientDetail: ClientDetail.IDevelopmentClientViewState
  clientEdit: ClientEdit.IClientEditState
  clientList: ClientList.IClientsListState
  commentEditor: CommentEditor.ICommentEditorState
  connectionEdit: ConnectionEdit.IConnectionEditState
  connectionsList: ConnectionsList.IConnectionsListState
  connectionView: ConnectionView.IConnectionViewState
  contextReminder: ContextReminder.IContextReminderState
  criticalDatesEdit: CriticalDatesEdit.CriticalDatesEditState
  developmentProjectsList: DevelopmentProjects.IDevelopmentProjectsListState
  developmentSiteEdit: DevelopmentSiteEdit.IDevelopmentSiteEditState
  developmentSiteView: DevelopmentSiteView.IDevelopmentSiteViewState
  dueDiligenceCalendar: DueDiligenceCalendar.IDueDiligenceCalendarState
  dueDiligenceItemEdit: DueDiligenceItemEdit.IDueDiligenceItemEditState
  earnestMoneyList: EarnestMoneyList.IEarnestMoneyListState
  earnestMoneyListReport: EarnestMoneyListReport.IEarnestMoneyListState
  feedItemEditor: FeedItemEditor.IFeedItemEditorState
  feedItems: FeedItems.IFeedItemsState
  feedback: Feedback.IFeedbackState
  fileUpload: FileUpload.IFileUploadState
  forgotPassword: ForgotPassword.IForgotPasswordState
  formsList: FormsList.IFormsListState
  global: Global.IGlobalState
  globalSearch: GlobalSearch.IGlobalSearchState
  goalList: GoalList.IGoalsListState
  guestList: GuestList.IGuestListState
  guestView: GuestView.IGuestViewState
  leadsList: LeadsList.ILeadsListState
  listing: ListingView.IListingState
  listingEdit: ListingEdit.IListingEditState
  listingsCalendar: ListingsCalendar.IListingsCalendarState
  listingsList: ListingsList.IListingsListState
  listingSelector: ListingSelector.IListingSelectorState
  login: Login.ILoginState
  mapView: MapView.MapViewState
  mentionEditor: MentionEditor.IMentionEditorState
  messageList: MessageList.IMessagesListState
  notifications: NotificationsState
  notificationsList: NotificationsList.INotificationsListState
  pipeline: PipelineView.IPipelineState
  pipelineList: PipelineList.IPipelineListState
  preferencesEdit: PreferencesEdit.IPreferencesEditState
  projectedEarnings: ProjectedEarnings.IProjectedEarningsState
  projectedProfit: ProjectedProfit.IProjectedProfitState
  propertiesList: PropertiesList.IPropertiesListState
  property: PropertyView.IPropertyState
  propertyEdit: PropertyEdit.IPropertyEditState
  quickAdd: QuickAdd.IQuickAddState
  reactiveLayout: ReactiveLayout.IReactiveLayoutState
  router?: RouterState
  shareAttachment: ShareAttachment.IShareAttachmentState
  signsList: SignsList.ISignsListState
  signTransfer: SignTransfer.ISignTransferState
  signTypeList: SignTypeList.ISignTypesListState
  siteList: SiteList.ISiteListState
  soldPropertiesList: SoldPropertiesList.ISoldPropertiesListState
  successStoriesList: SuccessStoriesList.ISuccessStoriesListState
  successStoriesEdit: SuccessStoriesEdit.ISuccessStoriesEditState
  systemNotifications: SystemNotifications.ISystemNotificationsState
  teamsList: TeamsList.ITeamsListState
  teamView: TeamView.ITeamViewState
  todoList: TodoList.ITodoListState
  userEdit: UserEdit.IUserEditState
  userView: UserView.IUserViewState
  usersList: UsersList.IUsersListState
}

const ApplicationStateRecord = Record({
  account: new Account.AccountState(),
  activityFeed: new ActivityFeed.ActivityFeedState(),
  assignmentDetail: new AssignmentDetail.AssignmentDetailState(),
  assignmentForm: new AssignmentForm.AssignmentFormState(),
  assignmentsCalendar: new AssignmentsCalendar.AssignmentsCalendarState(),
  assignmentsList: new AssignmentsList.AssignmentsListState(),
  brokeragePipelinesCalendar: new BrokeragePipelinesCalendar.BrokeragePipelinesCalendarState(),
  brokeragePipelineEdit: new BrokeragePipelineEdit.PipelineEditState(),
  changePassword: new ChangePassword.ChangePasswordState(),
  citiesList: new CitiesList.CitiesListState(),
  cityEdit: new CityEdit.CityEditState(),
  cityView: new CityView.CityViewState(),
  clientDetail: new ClientDetail.DevelopmentClientViewState(),
  clientEdit: new ClientEdit.ClientEditState(),
  clientList: new ClientList.ClientsListState(),
  commentEditor: new CommentEditor.CommentEditorState(),
  connectionEdit: new ConnectionEdit.ConnectionEditState(),
  connectionView: new ConnectionView.ConnectionViewState(),
  connectionsList: new ConnectionsList.ConnectionsListState(),
  contextReminder: new ContextReminder.ContextReminderState(),
  criticalDatesEdit: new CriticalDatesEdit.CriticalDatesEditState(),
  developmentProjectsList: new DevelopmentProjects.DevelopmentProjectsListState(),
  developmentSiteEdit: new DevelopmentSiteEdit.DevelopmentSiteEditState(),
  developmentSiteView: new DevelopmentSiteView.DevelopmentSiteViewState(),
  dueDiligenceCalendar: new DueDiligenceCalendar.DueDiligenceCalendarState(),
  dueDiligenceItemEdit: new DueDiligenceItemEdit.DueDiligenceItemEditState(),
  earnestMoneyList: new EarnestMoneyList.EarnestMoneyListState(),
  earnestMoneyListReport: new EarnestMoneyListReport.EarnestMoneyListState(),
  feedItemEditor: new FeedItemEditor.FeedItemEditorState(),
  feedItems: new FeedItems.FeedItemsState(),
  feedback: new Feedback.FeedbackState(),
  fileUpload: new FileUpload.FileUploadState(),
  forgotPassword: new ForgotPassword.ForgotPasswordState(),
  formsList: new FormsList.FormsListState(),
  global: new Global.GlobalState(),
  globalSearch: new GlobalSearch.GlobalSearchState(),
  goalList: new GoalList.GoalsListState(),
  guestList: new GuestList.GuestListState(),
  guestView: new GuestView.GuestViewState(),
  leadsList: new LeadsList.LeadsListState(),
  listing: new ListingView.ListingState(),
  listingEdit: new ListingEdit.ListingEditState(),
  listingsCalendar: new ListingsCalendar.ListingsCalendarState(),
  listingsList: new ListingsList.ListingsListState(),
  listingSelector: new ListingSelector.ListingSelectorState(),
  login: new Login.LoginState(),
  mapView: new MapView.MapViewState(),
  mentionEditor: new MentionEditor.MentionEditorState(),
  messageList: new MessageList.MessagesListState(),
  notifications: undefined,
  notificationsList: new NotificationsList.NotificationsListState(),
  pipeline: new PipelineView.PipelineState(),
  pipelineList: new PipelineList.PipelineListState(),
  preferencesEdit: new PreferencesEdit.PreferencesEditState(),
  projectedEarnings: new ProjectedEarnings.ProjectedEarningsState(),
  projectedProfit: new ProjectedProfit.ProjectedProfitState(),
  propertiesList: new PropertiesList.PropertiesListState(),
  property: new PropertyView.PropertyState(),
  propertyEdit: new PropertyEdit.PropertyEditState(),
  quickAdd: new QuickAdd.QuickAddState(),
  reactiveLayout: new ReactiveLayout.ReactiveLayoutState(),
  router: undefined,
  shareAttachment: new ShareAttachment.ShareAttachmentState(),
  signTransfer: new SignTransfer.SignTransferState(),
  signTypeList: new SignTypeList.SignTypesListState(),
  signsList: new SignsList.SignsListState(),
  siteList: new SiteList.SiteListState(),
  soldPropertiesList: new SoldPropertiesList.SoldPropertiesListState(),
  successStoriesList: new SuccessStoriesList.SuccessStoriesListState(),
  successStoriesEdit: new SuccessStoriesEdit.SuccessStoriesEditState(),
  systemNotifications: new SystemNotifications.SystemNotificationsState(),
  teamView: new TeamView.TeamViewState(),
  teamsList: new TeamsList.TeamsListState(),
  todoList: new TodoList.TodoListState(),
  userEdit: new UserEdit.UserEditState(),
  userView: new UserView.UserViewState(),
  usersList: new UsersList.UsersListState(),
})

export class ApplicationState extends ApplicationStateRecord
  implements IApplicationState {
  public static fromJS(initialState?: Partial<IApplicationState>) {
    return initialState
      ? new ApplicationState({
          account: Account.AccountState.fromJS(initialState.account),
          activityFeed: ActivityFeed.ActivityFeedState.fromJS(
            initialState.activityFeed,
          ),
          assignmentDetail: AssignmentDetail.AssignmentDetailState.fromJS(
            initialState.assignmentDetail,
          ),
          assignmentForm: AssignmentForm.AssignmentFormState.fromJS(
            initialState.assignmentForm,
          ),
          assignmentsCalendar: AssignmentsCalendar.AssignmentsCalendarState.fromJS(
            initialState.assignmentsCalendar,
          ),
          assignmentsList: AssignmentsList.AssignmentsListState.fromJS(
            initialState.assignmentsList,
          ),
          brokeragePipelinesCalendar: BrokeragePipelinesCalendar.BrokeragePipelinesCalendarState.fromJS(
            initialState.brokeragePipelinesCalendar,
          ),
          brokeragePipelineEdit: BrokeragePipelineEdit.PipelineEditState.fromJS(
            initialState.brokeragePipelineEdit,
          ),
          changePassword: ChangePassword.ChangePasswordState.fromJS(
            initialState.changePassword,
          ),
          citiesList: CitiesList.CitiesListState.fromJS(
            initialState.citiesList,
          ),
          cityEdit: CityEdit.CityEditState.fromJS(initialState.cityEdit),
          cityView: CityView.CityViewState.fromJS(initialState.cityView),
          clientDetail: ClientDetail.DevelopmentClientViewState.fromJS(
            initialState.clientDetail,
          ),
          clientEdit: ClientEdit.ClientEditState.fromJS(
            initialState.clientEdit,
          ),
          clientList: ClientList.ClientsListState.fromJS(
            initialState.clientList,
          ),
          commentEditor: CommentEditor.CommentEditorState.fromJS(
            initialState.commentEditor,
          ),
          connectionEdit: ConnectionEdit.ConnectionEditState.fromJS(
            initialState.connectionEdit,
          ),
          connectionView: ConnectionView.ConnectionViewState.fromJS(
            initialState.connectionView,
          ),
          connectionsList: ConnectionsList.ConnectionsListState.fromJS(
            initialState.connectionsList,
          ),
          contextReminder: ContextReminder.ContextReminderState.fromJS(
            initialState.contextReminder,
          ),
          criticalDatesEdit: CriticalDatesEdit.CriticalDatesEditState.fromJS(
            initialState.criticalDatesEdit,
          ),
          developmentProjectsList: DevelopmentProjects.DevelopmentProjectsListState.fromJS(
            initialState.developmentProjectsList,
          ),
          developmentSiteEdit: DevelopmentSiteEdit.DevelopmentSiteEditState.fromJS(
            initialState.developmentSiteEdit,
          ),
          developmentSiteView: DevelopmentSiteView.DevelopmentSiteViewState.fromJS(
            initialState.developmentSiteView,
          ),
          dueDiligenceCalendar: DueDiligenceCalendar.DueDiligenceCalendarState.fromJS(
            initialState.dueDiligenceCalendar,
          ),
          dueDiligenceItemEdit: DueDiligenceItemEdit.DueDiligenceItemEditState.fromJS(
            initialState.dueDiligenceItemEdit,
          ),
          earnestMoneyList: EarnestMoneyList.EarnestMoneyListState.fromJS(
            initialState.earnestMoneyList,
          ),
          earnestMoneyListReport: EarnestMoneyListReport.EarnestMoneyListState.fromJS(
            initialState.earnestMoneyListReport,
          ),
          feedItemEditor: FeedItemEditor.FeedItemEditorState.fromJS(
            initialState.feedItemEditor,
          ),
          feedItems: FeedItems.FeedItemsState.fromJS(initialState.feedItems),
          feedback: Feedback.FeedbackState.fromJS(initialState.feedback),
          fileUpload: FileUpload.FileUploadState.fromJS(
            initialState.fileUpload,
          ),
          forgotPassword: ForgotPassword.ForgotPasswordState.fromJS(
            initialState.forgotPassword,
          ),
          formsList: FormsList.FormsListState.fromJS(initialState.formsList),
          global: Global.GlobalState.fromJS(initialState.global),
          globalSearch: GlobalSearch.GlobalSearchState.fromJS(
            initialState.globalSearch,
          ),
          goalList: GoalList.GoalsListState.fromJS(initialState.goalList),
          guestList: GuestList.GuestListState.fromJS(initialState.guestList),
          guestView: GuestView.GuestViewState.fromJS(initialState.guestView),
          leadsList: LeadsList.LeadsListState.fromJS(initialState.leadsList),
          listing: ListingView.ListingState.fromJS(initialState.listing),
          listingEdit: ListingEdit.ListingEditState.fromJS(
            initialState.listingEdit,
          ),
          listingsCalendar: ListingsCalendar.ListingsCalendarState.fromJS(
            initialState.listingsCalendar,
          ),
          listingsList: ListingsList.ListingsListState.fromJS(
            initialState.listingsList,
          ),
          listingSelector: ListingSelector.ListingSelectorState.fromJS(
            initialState.listingSelector,
          ),
          login: Login.LoginState.fromJS(initialState.login),
          mentionEditor: MentionEditor.MentionEditorState.fromJS(
            initialState.mentionEditor,
          ),
          mapView: MapView.MapViewState.fromJS(initialState.mapView),
          messageList: MessageList.MessagesListState.fromJS(
            initialState.messageList,
          ),
          notifications: initialState.notifications,
          notificationsList: NotificationsList.NotificationsListState.fromJS(
            initialState.notificationsList,
          ),
          pipeline: PipelineView.PipelineState.fromJS(initialState.pipeline),
          pipelineList: PipelineList.PipelineListState.fromJS(
            initialState.pipelineList,
          ),
          preferencesEdit: PreferencesEdit.PreferencesEditState.fromJS(
            initialState.preferencesEdit,
          ),
          projectedEarnings: ProjectedEarnings.ProjectedEarningsState.fromJS(
            initialState.projectedEarnings,
          ),
          projectedProfit: ProjectedProfit.ProjectedProfitState.fromJS(
            initialState.projectedProfit,
          ),
          propertiesList: PropertiesList.PropertiesListState.fromJS(
            initialState.propertiesList,
          ),
          property: PropertyView.PropertyState.fromJS(initialState.property),
          propertyEdit: PropertyEdit.PropertyEditState.fromJS(
            initialState.propertyEdit,
          ),
          quickAdd: QuickAdd.QuickAddState.fromJS(initialState.quickAdd),
          reactiveLayout: ReactiveLayout.ReactiveLayoutState.fromJS(
            initialState.reactiveLayout,
          ),
          router: initialState.router,
          shareAttachment: ShareAttachment.ShareAttachmentState.fromJS(
            initialState.shareAttachment,
          ),
          signTransfer: SignTransfer.SignTransferState.fromJS(
            initialState.signTransfer,
          ),
          signTypeList: SignTypeList.SignTypesListState.fromJS(
            initialState.signTypeList,
          ),
          signsList: SignsList.SignsListState.fromJS(initialState.signsList),
          siteList: SiteList.SiteListState.fromJS(initialState.siteList),
          soldPropertiesList: SoldPropertiesList.SoldPropertiesListState.fromJS(
            initialState.soldPropertiesList,
          ),
          successStoriesList: SuccessStoriesList.SuccessStoriesListState.fromJS(
            initialState.successStoriesList,
          ),
          successStoriesEdit: SuccessStoriesEdit.SuccessStoriesEditState.fromJS(
            initialState.successStoriesEdit,
          ),
          systemNotifications: SystemNotifications.SystemNotificationsState.fromJS(
            initialState.systemNotifications,
          ),
          teamView: TeamView.TeamViewState.fromJS(initialState.teamView),
          teamsList: TeamsList.TeamsListState.fromJS(initialState.teamsList),
          todoList: TodoList.TodoListState.fromJS(initialState.todoList),
          userEdit: UserEdit.UserEditState.fromJS(initialState.userEdit),
          userView: UserView.UserViewState.fromJS(initialState.userView),
          usersList: UsersList.UsersListState.fromJS(initialState.usersList),
        })
      : new ApplicationState()
  }

  public readonly account: Account.AccountState
  public readonly activityFeed: ActivityFeed.ActivityFeedState
  public readonly assignmentDetail: AssignmentDetail.AssignmentDetailState
  public readonly assignmentForm: AssignmentForm.AssignmentFormState
  public readonly assignmentsCalendar: AssignmentsCalendar.AssignmentsCalendarState
  public readonly assignmentsList: AssignmentsList.AssignmentsListState
  public readonly brokeragePipelinesCalendar: BrokeragePipelinesCalendar.BrokeragePipelinesCalendarState
  public readonly brokeragePipelineEdit: BrokeragePipelineEdit.PipelineEditState
  public readonly changePassword: ChangePassword.ChangePasswordState
  public readonly citiesList: CitiesList.CitiesListState
  public readonly cityEdit: CityEdit.CityEditState
  public readonly cityView: CityView.CityViewState
  public readonly clientDetail: ClientDetail.DevelopmentClientViewState
  public readonly clientEdit: ClientEdit.ClientEditState
  public readonly clientList: ClientList.ClientsListState
  public readonly commentEditor: CommentEditor.CommentEditorState
  public readonly connectionEdit: ConnectionEdit.ConnectionEditState
  public readonly connectionsList: ConnectionsList.ConnectionsListState
  public readonly connectionView: ConnectionView.ConnectionViewState
  public readonly contextReminder: ContextReminder.ContextReminderState
  public readonly criticalDatesEdit: CriticalDatesEdit.CriticalDatesEditState
  public readonly developmentProjectsList: DevelopmentProjects.DevelopmentProjectsListState
  public readonly developmentSiteEdit: DevelopmentSiteEdit.DevelopmentSiteEditState
  public readonly developmentSiteView: DevelopmentSiteView.DevelopmentSiteViewState
  public readonly dueDiligenceCalendar: DueDiligenceCalendar.DueDiligenceCalendarState
  public readonly dueDiligenceItemEdit: DueDiligenceItemEdit.DueDiligenceItemEditState
  public readonly earnestMoneyList: EarnestMoneyList.EarnestMoneyListState
  public readonly earnestMoneyListReport: EarnestMoneyListReport.EarnestMoneyListState
  public readonly feedback: Feedback.FeedbackState
  public readonly feedItemEditor: FeedItemEditor.FeedItemEditorState
  public readonly feedItems: FeedItems.FeedItemsState
  public readonly fileUpload: FileUpload.FileUploadState
  public readonly forgotPassword: ForgotPassword.ForgotPasswordState
  public readonly formsList: FormsList.FormsListState
  public readonly global: Global.GlobalState
  public readonly globalSearch: GlobalSearch.GlobalSearchState
  public readonly goalList: GoalList.GoalsListState
  public readonly guestList: GuestList.GuestListState
  public readonly guestView: GuestView.GuestViewState
  public readonly leadsList: LeadsList.LeadsListState
  public readonly listing: ListingView.ListingState
  public readonly listingEdit: ListingEdit.ListingEditState
  public readonly listingsCalendar: ListingsCalendar.ListingsCalendarState
  public readonly listingsList: ListingsList.ListingsListState
  public readonly listingSelector: ListingSelector.IListingSelectorState
  public readonly login: Login.LoginState
  public readonly mapView: MapView.MapViewState
  public readonly mentionEditor: MentionEditor.MentionEditorState
  public readonly messageList: MessageList.MessagesListState
  public readonly notifications: NotificationsState
  public readonly notificationsList: NotificationsList.NotificationsListState
  public readonly pipeline: PipelineView.PipelineState
  public readonly pipelineList: PipelineList.PipelineListState
  public readonly preferencesEdit: PreferencesEdit.PreferencesEditState
  public readonly projectedEarnings: ProjectedEarnings.ProjectedEarningsState
  public readonly projectedProfit: ProjectedProfit.ProjectedProfitState
  public readonly propertiesList: PropertiesList.PropertiesListState
  public readonly property: PropertyView.PropertyState
  public readonly propertyEdit: PropertyEdit.PropertyEditState
  public readonly quickAdd: QuickAdd.QuickAddState
  public readonly reactiveLayout: ReactiveLayout.ReactiveLayoutState
  public readonly router?: RouterState
  public readonly shareAttachment: ShareAttachment.ShareAttachmentState
  public readonly signsList: SignsList.SignsListState
  public readonly signTransfer: SignTransfer.SignTransferState
  public readonly signTypeList: SignTypeList.SignTypesListState
  public readonly siteList: SiteList.SiteListState
  public readonly successStoriesList: SuccessStoriesList.SuccessStoriesListState
  public readonly successStoriesEdit: SuccessStoriesEdit.SuccessStoriesEditState
  public readonly soldPropertiesList: SoldPropertiesList.SoldPropertiesListState
  public readonly systemNotifications: SystemNotifications.SystemNotificationsState
  public readonly teamsList: TeamsList.TeamsListState
  public readonly teamView: TeamView.TeamViewState
  public readonly todoList: TodoList.TodoListState
  public readonly userEdit: UserEdit.UserEditState
  public readonly userView: UserView.UserViewState
  public readonly usersList: UsersList.UsersListState

  constructor(props?: Partial<ApplicationState>) {
    props ? super(props) : super()
  }
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  account: Account.reducer,
  activityFeed: ActivityFeed.reducer,
  assignmentDetail: AssignmentDetail.reducer,
  assignmentForm: AssignmentForm.reducer,
  assignmentsCalendar: AssignmentsCalendar.reducer,
  assignmentsList: AssignmentsList.reducer,
  brokeragePipelinesCalendar: BrokeragePipelinesCalendar.reducer,
  brokeragePipelineEdit: BrokeragePipelineEdit.reducer,
  changePassword: ChangePassword.reducer,
  citiesList: CitiesList.reducer,
  cityEdit: CityEdit.reducer,
  cityView: CityView.reducer,
  clientDetail: ClientDetail.reducer,
  clientEdit: ClientEdit.reducer,
  clientList: ClientList.reducer,
  commentEditor: CommentEditor.reducer,
  connectionEdit: ConnectionEdit.reducer,
  connectionView: ConnectionView.reducer,
  connectionsList: ConnectionsList.reducer,
  contextReminder: ContextReminder.reducer,
  criticalDatesEdit: CriticalDatesEdit.reducer,
  developmentProjectsList: DevelopmentProjects.reducer,
  developmentSiteEdit: DevelopmentSiteEdit.reducer,
  developmentSiteView: DevelopmentSiteView.reducer,
  dueDiligenceCalendar: DueDiligenceCalendar.reducer,
  dueDiligenceItemEdit: DueDiligenceItemEdit.reducer,
  earnestMoneyList: EarnestMoneyList.reducer,
  earnestMoneyListReport: EarnestMoneyListReport.reducer,
  feedItemEditor: FeedItemEditor.reducer,
  feedItems: FeedItems.reducer,
  feedback: Feedback.reducer,
  fileUpload: FileUpload.reducer,
  forgotPassword: ForgotPassword.reducer,
  formsList: FormsList.reducer,
  global: Global.reducer,
  globalSearch: GlobalSearch.reducer,
  goalList: GoalList.reducer,
  guestList: GuestList.reducer,
  guestView: GuestView.reducer,
  leadsList: LeadsList.reducer,
  listing: ListingView.reducer,
  listingEdit: ListingEdit.reducer,
  listingsCalendar: ListingsCalendar.reducer,
  listingsList: ListingsList.reducer,
  listingSelector: ListingSelector.reducer,
  login: Login.reducer,
  mapView: MapView.reducer,
  mentionEditor: MentionEditor.reducer,
  messageList: MessageList.reducer,
  notifications,
  notificationsList: NotificationsList.reducer,
  pipeline: PipelineView.reducer,
  pipelineList: PipelineList.reducer,
  preferencesEdit: PreferencesEdit.reducer,
  projectedEarnings: ProjectedEarnings.reducer,
  projectedProfit: ProjectedProfit.reducer,
  propertiesList: PropertiesList.reducer,
  property: PropertyView.reducer,
  propertyEdit: PropertyEdit.reducer,
  quickAdd: QuickAdd.reducer,
  reactiveLayout: ReactiveLayout.reducer,
  shareAttachment: ShareAttachment.reducer,
  signTransfer: SignTransfer.reducer,
  signTypeList: SignTypeList.reducer,
  signsList: SignsList.reducer,
  siteList: SiteList.reducer,
  soldPropertiesList: SoldPropertiesList.reducer,
  successStoriesList: SuccessStoriesList.reducer,
  successStoriesEdit: SuccessStoriesEdit.reducer,
  systemNotifications: SystemNotifications.reducer,
  teamView: TeamView.reducer,
  teamsList: TeamsList.reducer,
  todoList: TodoList.reducer,
  userEdit: UserEdit.reducer,
  userView: UserView.reducer,
  usersList: UsersList.reducer,
}

export function createRootReducer(history: History) {
  const reducer = combineReducers<ApplicationState>({
    ...reducers,
    router: connectRouter(history),
  })
  return reducer
}
